import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, EMAIL_MAILTO } from "../data/contact";

const ITEMS = [
  { icon: Phone, label: "Call the Speedy team", value: PHONE_DISPLAY, href: PHONE_TEL },
  { icon: Mail, label: "Email us", value: EMAIL, href: EMAIL_MAILTO },
  { icon: MapPin, label: "Based in Sydney", value: "545 Merrylands Road, Merrylands NSW 2160" },
  { icon: Clock, label: "Availability", value: "Round-the-clock · 7 days · Sydney time" },
];

export default function ContactSection() {
  return (
    <section className="mx-auto max-w-7xl px-5 md:px-10 py-24" data-testid="home-contact">
      <div className="relative overflow-hidden rounded-lg border border-gold/20 bg-obsidian-800 p-8 md:p-16 grid-lines">
        <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <Overline className="text-gold">Talk to Us</Overline>
            <h2 className="mt-5 font-heading font-black text-4xl md:text-6xl tracking-tight">
              LET'S BUILD <span className="gold-text">YOUR COURT.</span>
            </h2>
            <p className="mt-5 text-zinc-300 max-w-md">
              Ready to transform your court? Reach the Speedy Resurfacing team directly, or send your details for a fast, no-obligation quote.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/quote" data-testid="contact-quote" className="group inline-flex items-center gap-2 rounded-sm bg-neon px-7 py-4 font-bold text-obsidian hover:bg-neon-hover transition-colors shadow-neon">
                Get a Free Quote <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </Link>
              <a href={PHONE_TEL} data-testid="contact-call" className="inline-flex items-center gap-2 rounded-sm border border-white/25 px-7 py-4 font-bold hover:border-gold hover:text-gold transition-colors">
                <Phone size={18} /> Call Now
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="grid sm:grid-cols-2 gap-4">
              {ITEMS.map((it, i) => {
                const Icon = it.icon;
                const Comp = it.href ? "a" : "div";
                return (
                  <Comp key={i} href={it.href} data-testid={`contact-item-${i}`}
                    className={`glass rounded-lg p-5 flex flex-col gap-2 transition-colors ${it.href ? "hover:border-neon/50" : ""}`}>
                    <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-white/5 text-neon"><Icon size={18} /></span>
                    <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{it.label}</span>
                    <span className="font-heading font-bold text-sm text-white break-words">{it.value}</span>
                  </Comp>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
